import { approve } from "@bracket/contractor-next/erc20";
import { wagmiConfig as config, } from "@wagmiconfig";
import type { TokenDefinition, } from "@bracket/chainography";



/**
 * Approves the BRKTETH contract to spend tokens on behalf of the user
 * @param {Object} params - The parameters object
 * @param {TokenDefinition} params.token - The token to approve spending for
 * @param {bigint|number} params.amount - The amount of tokens to approve
 * @returns {Promise<boolean>} True if approval was successful, false if user rejected, throws on other errors
 */
export const approveTokenSpend = async ({
	token,
	amount,
	spender = "BRKTETH",
}: {
	token: TokenDefinition;
	amount: bigint|number;
	spender?: "BRKTETH" | "BrktETHRouter";
}): Promise<boolean> => {
	try {
		await approve({
			token,
			amount,
			spender,
			config,
		});
		return true;
	} catch (err) {
		if(err instanceof Error && err.message && err.message.includes("User rejected the request")) {
			return false;
		}
		throw err;
	}
};
